module.exports = "/build/web/svg/social/small/website.d96f48cf6c6d4f0a8138f3db64e0b585.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/social/small/website.svg
// module id = 196
// module chunks = 24